import { useEffect, useMemo, useState } from "react";
import { post } from "../js/post";
import "../css/OptometryScreen.css";
import "../css/Glasses.css";
import moment from "moment";
import {
  glassesStructure,
  inputOnEnter,
  userData,
  selectedOptic,
  areObjectsEqual,
  rangeOptions,
  focusElement,
  genderProductOptions,
  availabilityProductOptions,
  checkOfferPrice,
  calculateDiscountFromTotal,
  calculateAddFromTotal,
  calculateTotalLens,
  calculateTransposition,
} from "../js/utils";
import InputData from "./InputData";
import InputDataControl from "../support-extra/components/InputDataControl";
import InputIconSearch from "./InputIconSearch";
import DropdownFilter from "./DropdownFilter";
import Dropdown from "./Dropdown";
import ButtonIconV from "./ButtonIconV";
import CheckBox from "./CheckBox";
import ButtonIconH from "./ButtonIconH";
import SummarySectionBox from "./SummarySectionBox";
import ActionPopup from "./ActionPopup";
import Insurance from "./Insurance";
import ProgressiveData from "./ProgressiveData";
import Extras from "./Extras";
import HealthData from "../support-extra/components/HealthData";
import ObservationsPanel from "./ObservationsPanel";
import AssociateProduct from "./AssociateProduct";
import LoadingScreen from "./LoadingScreen";
import SalesManagement from "./SalesManagement";
import Decentration from "./Decentration";
import { calculateDtos } from "../js/calculateDtos";
import { getPatientProductPrice } from "../js/patientProductPrice";
import { useAgents } from "../hooks/useAgents";
import { useBrands } from "../hooks/useBrands";
import { useSupplierBrandsByFamily } from "../hooks/useSupplierBrandsByFamily";
import { useSuppliers } from "../hooks/useSuppliers";
import { useFamilySuppliers } from "../hooks/useFamilySuppliers";
import { useGlassesTypes } from "../hooks/useGlassesTypes";
import { useCampaigns } from "../hooks/useCampaigns";
import { useObservations } from "../hooks/useObservations";
import { useModelsTradeNamesAndProducts } from "../hooks/useModelsTradeNamesAndProducts";
import { GlassesReportPopup } from "./GlassesReportPopup";
import CentralCatalogPopup from "../support-extra/components/CentralCatalogPopup";

const ONLINE_ORDER_URL =
  "https://qa.euopsysweb.com/sso?refID=ESSSPAINES&loginName=610551&loginEncryptedPassword=DqKTCwJs1IZAkckNgGnpQeLZycoco%2FPsBDs0ZgI4qu16A9xw4DC5oNWhSzt5nmzweZtBWTHgdyNFtqiAQddmg%2B6%2Fbkcd%2BwutUsIeiahYWd2TZ6Wj1H35imsm1VzEm%2FjM9%2BETGBqr3EzWFB5VzCmSSqnhV69c%2FxQpVh5I3w77WJRtlNKclLQmJL8Ydog%2Fcj6gf9PF1N%2BMOlLuPICeXtlauFKOlLwTwAcVETJGpGS%2FHWJPb7Vpq7yJK6fhOrPoYCyjE%2FLHiaBSyX1DM5nypfHU6v7C%2FIzd%2FG%2BtRDYRK829A1GWaGXxHgvxvPTOVOG26gIIGvJ2%2Fik2Z%2BhFW%2BwGpUKOUw%3D%3D&locale=es-ES&ExternalId=999658&PmsId=VWOPTIWIN";

export default function Glasses({
  patientInfo,
  id,
  onClose,
  createPopupQuestion,
  removePopupQuestion,
  onClickMenuOption,
}) {
  const [actionPopup, setActionPopup] = useState(null);
  const [dateHistoryList, setDateHistoryList] = useState([]);
  const [selectedDate, setSelectedDate] = useState({ id: "", text: "" });
  const [glassesId, setGlassesId] = useState(id);
  const [currentGlasses, setCurrentGlasses] = useState(glassesStructure);
  const [currentGlassesEdit, setCurrentGlassesEdit] =
    useState(glassesStructure);
  const agentList = [{ id: "", text: "" }, ...useAgents()];
  const reasonList = [{ id: "", text: "" }, ...useCampaigns()];
  const [recordTypeList, setRecordTypeList] = useState([]);
  const glassesTypeList = useGlassesTypes();
  const [frameMaterialList, setFrameMaterialList] = useState([]);
  const [shapeList, setShapeList] = useState([]);
  const [lensesMaterialList, setLensesMaterialList] = useState([]);
  const [lensesTypeList, setLensesTypeList] = useState([]);
  const [insurance, setInsurance] = useState({});
  const [progressiveData, setProgressiveData] = useState({});
  const [extras, setExtras] = useState([]);
  const { list: observations, refresh: refreshObservations } = useObservations(
    currentGlassesEdit.idFicha,
    "Ficha",
  );
  const { list: repairs, refresh: refreshRepairs } = useObservations(
    currentGlassesEdit.idFicha,
    "Reparacion",
  );
  const [healthData, setHealthData] = useState([]);
  const [actionComponent, setActionComponent] = useState(null);
  const [toggleObservationPanel, setToggleObservationPanel] = useState(false);
  const [toggleRepairPanel, setToggleRepairPanel] = useState(false);
  const frameSuppliers = useFamilySuppliers([4, 6]);
  const frameSupplierList = useMemo(
    () => [
      { id: -1, text: "" },
      ...frameSuppliers.map((e) => ({ id: e.id, text: e.nombre })),
    ],
    [frameSuppliers],
  );
  const lensSuppliers = useSuppliers(1)[0];
  const leftLensSupplierList = useMemo(
    () => [
      { id: -1, text: "" },
      ...lensSuppliers.map((e) => ({ id: e.id, text: e.nombre })),
    ],
    [lensSuppliers],
  );
  const rightLensSupplierList = useMemo(
    () => [
      { id: -1, text: "" },
      ...lensSuppliers.map((e) => ({ id: e.id, text: e.nombre })),
    ],
    [lensSuppliers],
  );
  const [selectedFrameSupplier, setSelectedFrameSupplier] = useState({
    id: -1,
    text: "",
  });
  const [selectedLeftLensSupplier, setSelectedLeftLensSupplier] = useState({
    id: -1,
    text: "",
  });
  const [selectedRightLensSupplier, setSelectedRightLensSupplier] = useState({
    id: -1,
    text: "",
  });
  const rawFrameBrandList = useSupplierBrandsByFamily(
    [4, 6],
    selectedFrameSupplier.id === -1 ? [] : [selectedFrameSupplier.id],
  );
  const frameBrandList = useMemo(() => {
    const brands = rawFrameBrandList.map((e) => ({ id: e, text: e }));
    return [{ id: "", text: "" }, ...brands];
  }, [rawFrameBrandList]);
  const rawFrameModelsList = useModelsTradeNamesAndProducts(
    [4, 6],
    selectedFrameSupplier.id,
    [currentGlassesEdit.datosMontura.marca],
  )[0];
  const frameModelsList = useMemo(() => {
    const models = rawFrameModelsList.map((e) => ({ id: e, text: e }));
    // console.log(models, rawFrameModelsList);
    return [{ id: "", text: "" }, ...models];
  }, [rawFrameModelsList]);

  const rawLeftLensBrandList = useBrands(1, selectedLeftLensSupplier.id)[0];
  const leftLensBrandList = useMemo(() => {
    const brands = rawLeftLensBrandList.map((e) => ({ id: e, text: e }));
    return [{ id: "", text: "" }, ...brands];
  }, [rawLeftLensBrandList]);
  const rawLeftLensModelsList = useModelsTradeNamesAndProducts(
    [1],
    selectedLeftLensSupplier.id,
    [currentGlassesEdit.datosLenteOI.marca],
  )[0];
  const leftLensModelsList = useMemo(() => {
    const models = rawLeftLensModelsList.map((e) => ({ id: e, text: e }));
    // console.log(models, rawLeftLensModelsList);
    return [{ id: "", text: "" }, ...models];
  }, [rawLeftLensModelsList]);

  const rawRightLensBrandList = useBrands(1, selectedRightLensSupplier.id)[0];
  const rightLensBrandList = useMemo(() => {
    const brands = rawRightLensBrandList.map((e) => ({ id: e, text: e }));
    return [{ id: "", text: "" }, ...brands];
  }, [rawRightLensBrandList]);
  const rawRightLensModelsList = useModelsTradeNamesAndProducts(
    [1],
    selectedRightLensSupplier.id,
    [currentGlassesEdit.datosLenteOD.marca],
  )[0];
  const rightLensModelsList = useMemo(() => {
    const models = rawRightLensModelsList.map((e) => ({ id: e, text: e }));
    // console.log(models, rawRightLensModelsList);
    return [{ id: "", text: "" }, ...models];
  }, [rawRightLensModelsList]);

  const [loadingData, setLoadingData] = useState(true);
  const [total, setTotal] = useState(0);
  const [lastOptometry, setLastOptometry] = useState(null);
  const [reportPopup, setReportPopup] = useState(false);
  const [centralCatalogPopup, setCentralCatalogPopup] = useState(null);
  const [tarifaOD, setTarifaOD] = useState(null);
  const [tarifaOI, setTarifaOI] = useState(null);

  /*useEffect(() => { console.log("tarifaOD: ", tarifaOD); }, [tarifaOD]);
  useEffect(() => { console.log("tarifaOI: ", tarifaOI); }, [tarifaOI]);*/

  // console.log("currentGlassesEdit: ", currentGlassesEdit);
  // console.log("extras: ", extras);

  const getRecordTypeList = async () => {
    let response = await post("/support-extra/fichas/ListarTipoFichas.php", {
      token: userData.token,
      familia: currentGlassesEdit.gafasSol ? 6 : 4,
    });
    setRecordTypeList([
      { id: "", text: "" },
      ...response.map((e) => ({ id: e.codigo, text: e.descripcion })),
    ]);
  };

  const getFrameMaterialList = async () => {
    const response = await post("ListarMaterialesMontura.php", {
      token: userData.token,
    });
    setFrameMaterialList([
      { id: "", text: "" },
      ...response.map((e) => ({ id: e.descripcion, text: e.descripcion })),
    ]);
  };

  const getShapeList = async () => {
    const response = await post("ListarFormasMontura.php", {
      token: userData.token,
    });
    setShapeList([
      { id: "", text: "" },
      ...response.map((e) => ({ id: e.descripcion, text: e.descripcion })),
    ]);
  };

  const getLensesMaterialList = async () => {
    const response = await post("ListarMaterialesLenteOftalmica.php", {
      token: userData.token,
    });
    setLensesMaterialList([
      { id: "", text: "" },
      ...response.map((e) => ({ id: e.descripcion, text: e.descripcion })),
    ]);
  };

  const getLensesTypeList = async () => {
    const response = await post("ListarTiposLenteOftalmica.php", {
      token: userData.token,
    });
    setLensesTypeList([
      { id: "", text: "" },
      ...response.map((e) => ({ id: e.descripcion, text: e.descripcion })),
    ]);
  };

  const getInsurance = async () => {
    const response = await post("/support-extra/fichas/ObtenerSeguro.php", {
      token: userData.token,
      idFicha: currentGlassesEdit.idFicha,
    });
    setInsurance(response);
  };

  const getProgressiveData = async () => {
    const response = await post(
      "/support-extra/fichas/ObtenerDatosProgresivos.php",
      {
        token: userData.token,
        idFicha: currentGlassesEdit.idFicha,
      },
    );
    setProgressiveData(response);
  };

  const getExtras = async () => {
    const response = await post("/support-extra/fichas/ListarFichaExtra.php", {
      token: userData.token,
      idFicha: currentGlassesEdit.idFicha,
    });

    setExtras(response);
  };

  const getHealthData = async () => {
    const response = await post("ListarDatosSanitarios.php", {
      token: userData.token,
      idPaciente: patientInfo.id,
      optica: selectedOptic.id,
      codigos: [
        currentGlassesEdit.datosMontura.codigo,
        currentGlassesEdit.datosLenteOD.codigo,
        currentGlassesEdit.datosLenteOI.codigo,
      ],
    });
    setHealthData(response);
  };

  const getGlassesHistory = async () => {
    const response = await post(
      "/support-extra/fichas/ListarHistoricoFichaGafas.php",
      {
        token: userData.token,
        idPaciente: patientInfo.id,
        completo: 1,
      },
    );
    if (response.length > 0) {
      const found = response.find((e) => {
        return e.idFichaGafas === glassesId;
      });
      if (found) {
        setSelectedDate({
          id: found.idFichaGafas,
          text: found.fecha,
        });
        setGlassesId(found.idFichaGafas);
      }
    }
    setDateHistoryList(response);
  };

  const resetGlassesState = () => {
    setCurrentGlasses({
      ...glassesStructure,
      fechaCreacion: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
    setCurrentGlassesEdit({
      ...glassesStructure,
      fechaCreacion: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
    setGlassesId(-1);
    setSelectedDate({
      id: -1,
      text: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
    setSelectedFrameSupplier({ id: -1, text: "" });
    setSelectedLeftLensSupplier({ id: -1, text: "" });
    setSelectedRightLensSupplier({ id: -1, text: "" });
  };

  function showNotProductFoundMessage(code, index) {
    createPopupQuestion(
      `No existe ningún producto con el código ${code}.`,
      () => {
        removePopupQuestion();
        focusElement(index);
      },
      null,
      "Entendido",
    );
  }

  function checkSaved() {
    createPopupQuestion(
      `Por favor, guarde la ficha primero.`,
      () => {
        removePopupQuestion();
      },
      null,
      "Entendido",
    );
  }

  const getProductPrice = (product) =>
    getPatientProductPrice({
      product,
      idPaciente: patientInfo?.id,
      createPopupQuestion,
      removePopupQuestion,
    });

  const searchFrameByCode = async (code) => {
    let codigo = code || currentGlassesEdit.datosMontura.codigo;
    codigo = !codigo || codigo === "0" ? "40" : codigo;

    const payload = {
      token: userData.token,
      codigo,
      tipoCodigo: -1,
      idOptica: selectedOptic.id,
    };

    let response = await post("ObtenerMontura.php", payload);
    // console.log("BUSCANDO MONTURA: ", payload, response);

    if (!response.id) {
      codigo = !codigo || codigo === "0" || codigo === "40" ? "60" : codigo;
      // console.log(
      // "BUSCANDO GAFA DE SOL: ",
      // {
      // ...payload,
      // codigo: codigo,
      // },
      // response,
      // );
      response = await post("ObtenerGafasSol.php", {
        ...payload,
        codigo: codigo,
      });
    }

    if (response.id) {
      const isSunGlasses = response.codigoOPTIWIN.startsWith("6");
      const price = await getProductPrice(response);

      setCurrentGlassesEdit((prev) => ({
        ...prev,
        datosMontura: {
          ...prev.datosMontura,
          codigo: response.codigoOPTIWIN,
          nombreProveedor: response.nombreProveedor,
          idProveedor: response.idProveedor,
          marca: response.marca,
          modelo: response.modelo,
          calibre1: response.calibre,
          calibre2: response.puente,
          material: response.material,
          genero: response.genero,
          forma: response.forma,
          color: response.color,
          colorCristal: isSunGlasses ? response.colorCristal : "",
          varilla: response.varilla,
          descuento: price.descuento,
          total: calculateLineTotal(price.pvp, price.descuento),
          dtoMaximo: response.dtoMaximo,
          pvp: price.pvp,
        },
      }));
      setTimeout(() => {
        focusElement(codigo === "40" || codigo === "60" ? 62 : 76);
      }, 100);
    } else {
      showNotProductFoundMessage(codigo, 61);
    }
  };

  const searchLensByCode = async (side, code) => {
    const lensKey = side === 0 ? "datosLenteOD" : "datosLenteOI";
    let codigo = code || currentGlassesEdit[lensKey].codigo;
    codigo = !codigo || codigo === "0" ? "10" : codigo;

    if (!codigo) return;

    const lensResponse = await fetchLensData(codigo);

    if (!lensResponse?.id) {
      const index = side === 0 ? 76 : 101;
      showNotProductFoundMessage(codigo, index);
      return;
    }

    const nextIndex =
      side === 0 ? (codigo === "10" ? 77 : 101) : codigo === "10" ? 102 : 126;
    setTimeout(() => {
      focusElement(nextIndex);
    }, 100);

    const stockResponse = await fetchProductStock(
      lensResponse.codigoOPTIWIN,
      selectedOptic.id,
    );

    const price = await getProductPrice(lensResponse);

    const updatedLensData = mapLensData(
      currentGlassesEdit[lensKey],
      lensResponse,
      stockResponse,
      price,
    );
    setCurrentGlassesEdit((prev) => ({
      ...prev,
      [lensKey]: updatedLensData,
    }));
  };

  const fetchLensData = async (codigo) => {
    const payload = {
      token: userData.token,
      codigo,
      tipoCodigo: -1,
      idOptica: selectedOptic.id,
    };
    const response = await post("ObtenerLenteOftalmica.php", payload);
    return response;
  };

  const fetchProductStock = async (codigoOPTIWIN, idOptica) => {
    return await post("ObtenerStockProducto.php", {
      token: userData.token,
      codigo: codigoOPTIWIN,
      idOptica,
    });
  };

  const mapLensData = (currentLensData, response, stockResponse, price) => ({
    ...currentLensData,
    codigo: response.codigoOPTIWIN,
    nombreProveedor: response.nombreProveedor,
    idProveedor: response.idProveedor,
    marca: response.marca,
    nombreComercial: response.nombreComercial,
    material: response.material,
    color: response.color,
    tratamiento: response.tratamiento,
    tipo: response.tipo,
    esf: response.esf,
    cil: response.cil,
    eje: response.eje,
    add: response.add,
    totalLente: response.total,
    ind: response.ind,
    dia: response.dia,
    alt: "",
    desc: "",
    descuento: price.descuento,
    disponibilidad: response.disponibilidad,
    dtoMaximo: response.dtoMaximo,
    total: calculateLineTotal(price.pvp, price.descuento),
    pvp: price.pvp,
  });

  const getGlasses = async (glassesId) => {
    const response = await post("/support-extra/fichas/ObtenerFichaGafas.php", {
      token: userData.token,
      idFichaGafas: glassesId,
      idOptica: selectedOptic.id,
    });

    // console.log(
    // "OBTENIENDO FICHA GAFAS: ",
    // {
    // token: userData.token,
    // idFichaGafas: glassesId,
    // idOptica: selectedOptic.id,
    // },
    // response,
    // );

    setCurrentGlasses({
      ...response,
      idPaciente: patientInfo.id,
      idFichaGafas: glassesId,
    });
    setCurrentGlassesEdit({
      ...response,
      idPaciente: patientInfo.id,
      idFichaGafas: glassesId,
    });
    const rawOD = response?.datosLenteOD?.datosPedidoHOYA;
    setTarifaOD(rawOD ? JSON.parse(rawOD) : null);
    const rawOI = response?.datosLenteOI?.datosPedidoHOYA;
    setTarifaOI(rawOI ? JSON.parse(rawOI) : null);
  };

  const cloneGlasses = async () => {
    const response = await post("/support-extra/fichas/ClonarFichaGafas.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
      idFichaGafas: glassesId,
    });

    setGlassesId(parseInt(response.idFichaGafas));
  };

  const cancelChanges = async () => {
    if (dateHistoryList.length > 0) {
      // 1. Si estamos creando una ficha, cargamos la última.
      if (glassesId === -1) {
        setSelectedDate({
          id: dateHistoryList[0].idFichaGafas,
          text: dateHistoryList[0].fecha,
        });
        setGlassesId(dateHistoryList[0].idFichaGafas);
        await getGlasses(dateHistoryList[0].idFichaGafas);
      } else {
        // 2. Si estamos viendo una ficha, cancelamos los cambios.
        setCurrentGlassesEdit(currentGlasses);
      }
    } else {
      setCurrentGlassesEdit(currentGlasses);
    }
  };

  const deleteGlasses = async () => {
    await post("/support-extra/fichas/EliminarFichaGafas.php", {
      token: userData.token,
      idFichaGafas: glassesId,
      idUsuario: userData.id,
    });
  };

  const selectGlassesAfterDeleting = async () => {
    const response = await post(
      "/support-extra/fichas/ListarHistoricoFichaGafas.php",
      {
        token: userData.token,
        idPaciente: patientInfo.id,
        completo: 1,
      },
    );
    if (response.length > 0) {
      setSelectedDate({
        id: response[0].idFichaGafas,
        text: response[0].fecha,
      });
      setGlassesId(response[0].idFichaGafas);
      setDateHistoryList(response);
      await getGlasses(response[0].idFichaGafas);
    } else {
      setSelectedDate({
        id: -1,
        text: moment().format("YYYY-MM-DD HH:mm:ss"),
      });
      setGlassesId(-1);
      setCurrentGlasses(glassesStructure);
      setCurrentGlassesEdit(glassesStructure);
    }
  };

  const checkDiscount = (glassesEdit = currentGlassesEdit) => {
    const checks = [
      {
        label: "la montura",
        data: glassesEdit.datosMontura,
        focusId: 74,
      },
      {
        label: "la lente oftálmica derecha",
        data: glassesEdit.datosLenteOD,
        focusId: 87,
      },
      {
        label: "la lente oftálmica izquierda",
        data: glassesEdit.datosLenteOI,
        focusId: 112,
      },
    ];

    for (const { label, data, focusId } of checks) {
      if (data.dtoMaximo !== "" && data.descuento > data.dtoMaximo) {
        createPopupQuestion(
          `El descuento de ${label} no puede ser mayor que su descuento máximo (${data.dtoMaximo}%).`,
          () => {
            removePopupQuestion();
            focusElement(focusId);
          },
          null,
          "Entendido",
        );
        return false;
      }
    }
    return true;
  };

  // Descuentos y precios se guardan como float con todos sus decimales (también
  // al enviarlos y recibirlos de los endpoints), pero los inputs los muestran
  // redondeados: el DTO a entero y los precios a céntimos. Por eso los inputs
  // no escriben en el estado al teclear, y al salir solo se recalcula si el
  // usuario ha cambiado el valor visible.
  const roundDto = (dto) => Math.round(parseFloat(dto) || 0);

  const roundPrice = (price) =>
    Math.round((parseFloat(price) || 0) * 100) / 100;

  const calculateLineTotal = (pvp, dto) =>
    (parseFloat(pvp) || 0) * (1 - (parseFloat(dto) || 0) / 100);

  const onBlurDiscount = (e, section, dtoKey, pvpKey, totalKey, validate) => {
    const inputValue = Number(e) || 0;
    const sectionData = currentGlassesEdit[section];
    if (inputValue === roundDto(sectionData[dtoKey])) return;

    const glassesEditN = {
      ...currentGlassesEdit,
      [section]: { ...sectionData, [dtoKey]: inputValue },
    };
    if (validate && !checkDiscount(glassesEditN)) {
      setCurrentGlassesEdit(glassesEditN);
      return;
    }
    glassesEditN[section][totalKey] = calculateLineTotal(
      sectionData[pvpKey],
      inputValue,
    );
    setCurrentGlassesEdit(glassesEditN);
  };

  const onBlurPrice = (e, section, pvpKey, dtoKey, totalKey) => {
    const inputValue = Number(e) || 0;
    const sectionData = currentGlassesEdit[section];
    if (inputValue === roundPrice(sectionData[pvpKey])) return;

    setCurrentGlassesEdit({
      ...currentGlassesEdit,
      [section]: {
        ...sectionData,
        [pvpKey]: inputValue,
        [totalKey]: calculateLineTotal(inputValue, sectionData[dtoKey]),
      },
    });
  };

  const onBlurLineTotal = (
    e,
    section,
    pvpKey,
    dtoKey,
    totalKey,
    dtoMax,
    focusId,
  ) => {
    const sectionData = currentGlassesEdit[section];
    if (parseFloat(e) === roundPrice(sectionData[totalKey])) return;

    const pvp = parseFloat(sectionData[pvpKey]) || 0;
    if (pvp === 0) {
      const inputValue = Number(e) || 0;
      setCurrentGlassesEdit((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [dtoKey]: 0,
          [pvpKey]: inputValue,
          [totalKey]: inputValue,
        },
      }));
      return;
    }

    const response = calculateDiscountFromTotal({
      pvp,
      total: e,
      dto: parseFloat(sectionData[dtoKey]) || 0,
      dtoMax,
      round: false,
    });
    const applyResponse = () =>
      setCurrentGlassesEdit((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [dtoKey]: response.dto,
          [totalKey]: response.total,
        },
      }));

    if (response.error !== "") {
      focusElement(focusId);
      createPopupQuestion(
        response.error,
        () => {
          removePopupQuestion();
          applyResponse();
        },
        null,
        "Entendido",
      );
    } else {
      applyResponse();
    }
  };

  const shouldClearEsf = (tipoGafa) => tipoGafa === "CE" || tipoGafa === "IN";

  const shouldClearAdd = (tipoGafa) =>
    tipoGafa === "CE" || tipoGafa === "IN" || tipoGafa === "LJ";

  const shouldClearTotalLente = (tipoGafa) => tipoGafa === "LJ";

  const cleanLensData = (lensData, tipoGafa) => ({
    ...lensData,
    esf: shouldClearEsf(tipoGafa) ? "" : lensData.esf,
    add: shouldClearAdd(tipoGafa) ? "" : lensData.add,
    totalLente: shouldClearTotalLente(tipoGafa) ? "" : lensData.totalLente,
  });

  const saveGlasses = async (onClose = () => {}) => {
    if (!checkDiscount()) {
      return;
    }
    if (validateData()) {
      const totalPrice = calculatePVP();
      const totalDiscount = calculateDiscount();
      const totalTotal = calculateTotal();

      const currentGlassesEditAux = {
        ...currentGlassesEdit,
        datosLenteOD: {
          ...cleanLensData(
            currentGlassesEdit.datosLenteOD,
            currentGlassesEdit.tipoGafa,
          ),
          datosPedidoHOYA: tarifaOD !== null ? JSON.stringify(tarifaOD) : "",
        },
        datosLenteOI: {
          ...cleanLensData(
            currentGlassesEdit.datosLenteOI,
            currentGlassesEdit.tipoGafa,
          ),
          datosPedidoHOYA: tarifaOI !== null ? JSON.stringify(tarifaOI) : "",
        },
      };
      const response = await post(
        "/support-extra/fichas/GuardarFichaGafas.php",
        {
          token: userData.token,
          idOptica: selectedOptic.id,
          idFichaGafas: glassesId,
          idPaciente: patientInfo.id,
          ...currentGlassesEditAux,
          precioTotal: totalTotal,
          dtoTotal: totalDiscount,
          pvptotal: totalPrice,
        },
      );

      // console.log(
      // "GUARDAR FICHA GAFAS: ",
      // {
      // token: userData.token,
      // idOptica: selectedOptic.id,
      // idFichaGafas: glassesId,
      // idPaciente: patientInfo.id,
      // ...currentGlassesEditAux,
      // precioTotal: totalTotal,
      // dtoTotal: totalDiscount,
      // pvptotal: totalPrice,
      // },
      // response,
      // );

      if (!response.idFichaGafas) return;

      setSelectedDate({
        id: response.idFichaGafas,
        text: currentGlassesEdit.fechaCreacion,
      });
      setGlassesId(response.idFichaGafas);
      setCurrentGlassesEdit({
        ...currentGlassesEdit,
        idFichaGafas: response.idFichaGafas,
        idFicha: response.idFicha,
        precioTotal: totalTotal,
        dtoTotal: totalDiscount,
        pvptotal: totalPrice,
      });
      setCurrentGlasses({
        ...currentGlassesEdit,
        idFichaGafas: response.idFichaGafas,
        idFicha: response.idFicha,
        precioTotal: totalTotal,
        dtoTotal: totalDiscount,
        pvptotal: totalPrice,
      });
      createPopupQuestion(
        `Los cambios se han guardado con éxito.`,
        () => {
          removePopupQuestion();
          setTimeout(() => {
            if (typeof onClose === "function") {
              onClose();
            }
          }, 0);
        },
        null,
        "Entendido",
      );
    } else {
      createPopupQuestion(
        `Por favor, rellene los campos obligatorios (*) y al menos una marca en algunos de sus apartados antes de guardar la ficha.`,
        async () => {
          removePopupQuestion();
          focusRequiredField();
        },
        null,
        "Entendido",
      );
    }
  };

  const loadLastOptometry = async (eye) => {
    let response = await post("/ObtenerUltimaOptometriaBasica.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idPaciente: patientInfo.id,
      tipoFicha: "Gafas",
    });
    if (response.idOptometria) {
      setLastOptometry(response);
      if (eye === 0) {
        setCurrentGlassesEdit((prev) => ({
          ...prev,
          datosLenteOD: {
            ...prev.datosLenteOD,
            esf: response.esfera_d,
            cil: response.cilindro_d,
            eje: response.eje_d,
            add:
              currentGlassesEdit.tipoGafa === "IN"
                ? response.adicion_d
                : response.cerca_d,
            totalLente:
              currentGlassesEdit.tipoGafa === "IN"
                ? response.intermedia_d
                : response.total_d,
          },
        }));
      } else {
        setCurrentGlassesEdit((prev) => ({
          ...prev,
          datosLenteOI: {
            ...prev.datosLenteOI,
            esf: response.esfera_i,
            cil: response.cilindro_i,
            eje: response.eje_i,
            add:
              currentGlassesEdit.tipoGafa === "IN"
                ? response.adicion_i
                : response.cerca_i,
            totalLente:
              currentGlassesEdit.tipoGafa === "IN"
                ? response.intermedia_i
                : response.total_i,
          },
        }));
      }
    }
  };

  const manageOptionsR = async (op) => {
    switch (op) {
      case 1:
        setCurrentGlassesEdit((prev) => ({
          ...prev,
          datosLenteOI: {
            ...currentGlassesEdit.datosLenteOD,
            esf: "",
            cil: "",
            eje: "",
            add: "",
            totalLente: "",
            desc: "",
          },
        }));
        break;
      case 2:
        await loadLastOptometry(0);
        break;
      case 3:
        const data = calculateTransposition(
          currentGlassesEdit.datosLenteOD.esf,
          currentGlassesEdit.datosLenteOD.totalLente,
          "",
          currentGlassesEdit.datosLenteOD.cil,
          currentGlassesEdit.datosLenteOD.eje,
        );
        setCurrentGlassesEdit((prev) => ({
          ...prev,
          datosLenteOD: {
            ...prev.datosLenteOD,
            esf: data.esferaT,
            totalLente: data.totalCT,
            cil: data.cilindroT,
            eje: data.ejeT,
          },
        }));
        break;
      case 4:
        handleOpenActionPopup("decentration");
        break;
      default:
        break;
    }
  };

  const manageOptionsL = async (op) => {
    switch (op) {
      case 1:
        setCurrentGlassesEdit((prev) => ({
          ...prev,
          datosLenteOD: {
            ...currentGlassesEdit.datosLenteOI,
            esf: "",
            cil: "",
            eje: "",
            add: "",
            totalLente: "",
            desc: "",
          },
        }));
        break;
      case 2:
        await loadLastOptometry(1);
        break;
      case 3:
        const data = calculateTransposition(
          currentGlassesEdit.datosLenteOI.esf,
          currentGlassesEdit.datosLenteOI.totalLente,
          "",
          currentGlassesEdit.datosLenteOI.cil,
          currentGlassesEdit.datosLenteOI.eje,
        );
        setCurrentGlassesEdit((prev) => ({
          ...prev,
          datosLenteOI: {
            ...prev.datosLenteOI,
            esf: data.esferaT,
            totalLente: data.totalCT,
            cil: data.cilindroT,
            eje: data.ejeT,
          },
        }));
        break;
      case 4:
        handleOpenActionPopup("decentration");
        break;
      default:
        break;
    }
  };

  const handleOpenActionPopup = (componentType) => {
    switch (componentType) {
      case "insurance":
        setActionComponent({
          name: "Seguro",
          component: (
            <Insurance
              id={currentGlassesEdit.idFicha}
              onClose={async () => {
                await getInsurance();
                setActionPopup(false);
              }}
            />
          ),
        });
        break;
      case "progressiveData":
        setActionComponent({
          name: "Datos progresivos",
          component: (
            <ProgressiveData
              id={currentGlassesEdit.idFicha}
              onClose={async () => {
                await getProgressiveData();
                setActionPopup(false);
              }}
            ></ProgressiveData>
          ),
        });
        break;
      case "extras":
        setActionComponent({
          name: "Extras",
          component: (
            <Extras
              id={currentGlassesEdit.idFicha}
              patientId={patientInfo?.id}
              createPopupQuestion={createPopupQuestion}
              removePopupQuestion={removePopupQuestion}
            ></Extras>
          ),
        });
        break;
      case "healthData": {
        const healthDataLines = healthData.map((item) => ({
          id: item.idDatoSanitario,
          line: {
            code: item.codigoArticulo,
            healthControl: {
              date: item.fechaCompra,
              description: item.descripcion,
              deliveryNote: item.nAlbaran,
              shippingNumber: item.nExpedicion,
              lotNumber: item.nLote,
            },
          },
        }));

        setActionComponent({
          name: "Datos sanitarios",
          component: (
            <HealthData
              lines={healthDataLines}
              mode="card"
              createPopupQuestion={createPopupQuestion}
              removePopupQuestion={removePopupQuestion}
              onClose={async () => {
                await getHealthData();
                setActionPopup(false);
                setActionComponent(null);
              }}
            ></HealthData>
          ),
        });
        break;
      }
      case "addFrame":
        setActionComponent({
          name: "Añadir montura",
          component: (
            <AssociateProduct
              famId={currentGlassesEdit.gafasSol ? 6 : 4}
              supplier={selectedFrameSupplier}
              brand={currentGlassesEdit.datosMontura.marca}
              onSelect={async (e) => {
                await searchFrameByCode(e);
                setActionPopup(false);
                setActionComponent(null);
              }}
            ></AssociateProduct>
          ),
        });
        break;
      case "addRightLens":
        setActionComponent({
          name: "Añadir lente OD",
          component: (
            <AssociateProduct
              famId={1}
              supplier={selectedRightLensSupplier}
              brand={currentGlassesEdit.datosLenteOD.marca}
              onSelect={async (e) => {
                await searchLensByCode(0, e);
                setActionPopup(false);
                setActionComponent(null);
              }}
            ></AssociateProduct>
          ),
        });
        break;
      case "addLeftLens":
        setActionComponent({
          name: "Añadir lente OI",
          component: (
            <AssociateProduct
              famId={1}
              supplier={selectedLeftLensSupplier}
              brand={currentGlassesEdit.datosLenteOI.marca}
              onSelect={async (e) => {
                await searchLensByCode(1, e);
                setActionPopup(false);
                setActionComponent(null);
              }}
            ></AssociateProduct>
          ),
        });
        break;
      case "sales":
        setActionComponent({
          name: "Venta · Encargo · Presupuesto · Proforma",
          component: (
            <SalesManagement
              id={currentGlassesEdit.idFicha}
              patientInfo={patientInfo}
              category={"gafas"}
              products={{
                motivo: currentGlassesEdit.motivoAgente,
                sol: currentGlassesEdit.gafasSol,
                prod1: {
                  ...currentGlassesEdit.datosMontura,
                  totalPrecio: currentGlassesEdit.datosMontura.total,
                },
                prod2: {
                  ...currentGlassesEdit.datosLenteOD,
                  totalPrecio:
                    (parseFloat(currentGlassesEdit.datosLenteOD.total) || 0) +
                    (parseFloat(
                      currentGlassesEdit.datosLenteOD.totalTratamiento,
                    ) || 0),
                },
                prod3: {
                  ...currentGlassesEdit.datosLenteOI,
                  totalPrecio:
                    (parseFloat(currentGlassesEdit.datosLenteOI.total) || 0) +
                    (parseFloat(
                      currentGlassesEdit.datosLenteOI.totalTratamiento,
                    ) || 0),
                },
                extras: extras,
              }}
              createPopupQuestion={createPopupQuestion}
              removePopupQuestion={removePopupQuestion}
              onClose={() => {
                setActionPopup(false);
                setActionComponent(null);
              }}
              onClickMenuOption={onClickMenuOption}
              onCloseCard={onCloseCard}
            ></SalesManagement>
          ),
        });
        break;
      case "decentration":
        setActionComponent({
          name: "Descentramiento",
          component: (
            <Decentration
              patientId={patientInfo.id}
              glassesType={currentGlassesEdit.tipoGafa}
              calibre={currentGlassesEdit.datosMontura.calibre1}
              puente={currentGlassesEdit.datosMontura.calibre2}
              onAccept={(e) => {
                setActionPopup(false);
                setActionComponent(null);
                setCurrentGlassesEdit((prev) => ({
                  ...prev,
                  datosLenteOD: {
                    ...prev.datosLenteOD,
                    desc: e.od,
                  },
                  datosLenteOI: {
                    ...prev.datosLenteOI,
                    desc: e.oi,
                  },
                }));
              }}
            ></Decentration>
          ),
        });
        break;
      default:
        setActionComponent(null);
    }
    setActionPopup(true);
  };

  async function reloadACList() {
    switch (actionComponent.name) {
      case "Extras":
        await getExtras();
        break;
      case "Datos sanitarios":
        await getHealthData();
        break;
      case "Datos progresivos":
        await getProgressiveData();
        break;
      case "Seguro":
        await getInsurance();
        break;
      default:
        break;
    }
  }

  function focusRequiredField() {
    const fields = [
      { value: currentGlassesEdit.empleado, elementId: 126 },
      { value: currentGlassesEdit.tipoFicha, elementId: 127 },
      { value: currentGlassesEdit.tipoGafa, elementId: 128 },
      { value: currentGlassesEdit.datosMontura.marca, elementId: 63 },
      { value: currentGlassesEdit.datosLenteOD.marca, elementId: 78 },
      { value: currentGlassesEdit.datosLenteOI.marca, elementId: 103 },
    ];

    const emptyField = fields.find((field) => field.value === "");
    if (emptyField) {
      focusElement(emptyField.elementId);
    }
  }

  function validateData() {
    const fieldsToValidate = [
      currentGlassesEdit.empleado,
      currentGlassesEdit.tipoFicha,
      currentGlassesEdit.tipoGafa,
    ];

    return (
      fieldsToValidate.every((field) => field !== "") &&
      (currentGlassesEdit.datosMontura.marca !== "" ||
        currentGlassesEdit.datosLenteOD.marca !== "" ||
        currentGlassesEdit.datosLenteOI.marca !== "")
    );
  }

  const handleChangeFrameData = (key, value) => {
    setCurrentGlassesEdit((prevState) => ({
      ...prevState,
      datosMontura: {
        ...prevState.datosMontura,
        [key]: value,
      },
    }));
  };

  const handleChangeLeftLensData = (key, value) => {
    setCurrentGlassesEdit((prevState) => ({
      ...prevState,
      datosLenteOI: {
        ...prevState.datosLenteOI,
        [key]: value,
      },
    }));
  };

  const handleChangeRightLensData = (key, value) => {
    setCurrentGlassesEdit((prevState) => ({
      ...prevState,
      datosLenteOD: {
        ...prevState.datosLenteOD,
        [key]: value,
      },
    }));
  };

  function calculateTotal() {
    const camposPrincipales = [
      currentGlassesEdit.datosMontura.total,
      currentGlassesEdit.datosLenteOD.total,
      currentGlassesEdit.datosLenteOD.totalTratamiento,
      currentGlassesEdit.datosLenteOI.total,
      currentGlassesEdit.datosLenteOI.totalTratamiento,
    ];

    const totalCampos = camposPrincipales.reduce((acc, val) => {
      const num = parseFloat(val);
      return acc + (isNaN(num) ? 0 : num);
    }, 0);

    const totalExtras = extras.reduce((acc, extra) => {
      const num = parseFloat(extra.total);
      return acc + (isNaN(num) ? 0 : num);
    }, 0);

    return totalCampos + totalExtras;
  }

  function calculatePVP() {
    let total = 0;
    if (extras.length > 0) {
      extras.map((e) => (total = total + parseFloat(e.pvp)));
    }
    total =
      parseFloat(currentGlassesEdit.datosMontura.pvp) +
      parseFloat(currentGlassesEdit.datosLenteOD.pvp) +
      parseFloat(currentGlassesEdit.datosLenteOD.pvpTratamiento) +
      parseFloat(currentGlassesEdit.datosLenteOI.pvp) +
      parseFloat(currentGlassesEdit.datosLenteOI.pvpTratamiento) +
      total;

    return total;
  }

  function calculateDiscount() {
    let total = 0;
    if (extras.length > 0) {
      extras.map(
        (e) => (total = total + (parseFloat(e.pvp) - parseFloat(e.total))),
      );
    }
    const discountMontura =
      parseFloat(currentGlassesEdit.datosMontura.pvp) -
      parseFloat(currentGlassesEdit.datosMontura.total);
    const discountLenteOD =
      parseFloat(currentGlassesEdit.datosLenteOD.pvp) -
      parseFloat(currentGlassesEdit.datosLenteOD.total);
    const discountLenteOI =
      parseFloat(currentGlassesEdit.datosLenteOI.pvp) -
      parseFloat(currentGlassesEdit.datosLenteOI.total);
    total = discountMontura + discountLenteOD + discountLenteOI + total;

    return total;
  }

  async function updateDiscounts(e) {
    let lines = [
      {
        total: currentGlassesEdit.datosMontura.total,
        dto: currentGlassesEdit.datosMontura.descuento,
        id: currentGlassesEdit.datosMontura.codigo,
        dtoMax: currentGlassesEdit.datosMontura.dtoMaximo,
      },
      {
        total: currentGlassesEdit.datosLenteOD.total,
        dto: currentGlassesEdit.datosLenteOD.descuento,
        id: currentGlassesEdit.datosLenteOD.codigo,
        dtoMax: currentGlassesEdit.datosLenteOD.dtoMaximo,
      },
      {
        total: currentGlassesEdit.datosLenteOD.totalTratamiento,
        dto: currentGlassesEdit.datosLenteOD.descuentoTratamiento,
        id: currentGlassesEdit.datosLenteOD.codigo,
        dtoMax: "",
      },
      {
        total: currentGlassesEdit.datosLenteOI.total,
        dto: currentGlassesEdit.datosLenteOI.descuento,
        id: currentGlassesEdit.datosLenteOI.codigo,
        dtoMax: currentGlassesEdit.datosLenteOI.dtoMaximo,
      },
      {
        total: currentGlassesEdit.datosLenteOI.totalTratamiento,
        dto: currentGlassesEdit.datosLenteOI.descuentoTratamiento,
        id: currentGlassesEdit.datosLenteOI.codigo,
        dtoMax: "",
      },
      ...extras.map((extra) => ({
        total: extra.total,
        dto: extra.dto,
        id: extra.codigo,
        dtoMax: extra.dtoMaximo,
      })),
    ];

    const updatedLines = calculateDtos(lines, e, false, false);

    if (updatedLines.error !== "") {
      createPopupQuestion(
        updatedLines.error,
        () => {
          removePopupQuestion();
          setTotal(calculateTotal());
        },
        null,
        "Entendido",
      );
      return;
    } else {
      createPopupQuestion(
        "Se han ajustado los descuentos de forma automática.",
        async () => {
          removePopupQuestion();
          focusElement(61);

          setCurrentGlassesEdit((prev) => ({
            ...prev,
            datosMontura: {
              ...prev.datosMontura,
              descuento: updatedLines.lines[0].dto,
              total: updatedLines.lines[0].total,
            },
            datosLenteOD: {
              ...prev.datosLenteOD,
              descuento: updatedLines.lines[1].dto,
              descuentoTratamiento: updatedLines.lines[2].dto,
              total: updatedLines.lines[1].total,
              totalTratamiento: updatedLines.lines[2].total,
            },
            datosLenteOI: {
              ...prev.datosLenteOI,
              descuento: updatedLines.lines[3].dto,
              descuentoTratamiento: updatedLines.lines[4].dto,
              total: updatedLines.lines[3].total,
              totalTratamiento: updatedLines.lines[4].total,
            },
          }));

          const updatedExtras = extras.map((extra) => {
            const found = updatedLines.lines.find((e) => e.id === extra.codigo);
            return found
              ? { ...extra, dto: found.dto, total: found.total }
              : extra;
          });

          await Promise.all(
            updatedExtras.map((extra) =>
              post("/support-extra/fichas/EditarFichaExtra.php", {
                token: userData.token,
                idExtra: extra.id,
                codigo: extra.codigo,
                descripcion: extra.descripcion,
                pvp: extra.pvp,
                iva: extra.iva,
                dto: extra.dto,
                dtoMaximo: extra.dtoMaximo,
                total: extra.total,
              }),
            ),
          );
          setTotal(e);
        },
        null,
        "Entendido",
      );
    }
  }

  const onCloseCard = () => {
    onClose();
  };

  const printFile = async (data) => {
    if (glassesId === -1) return;
    const response = await post(
      "/support-extra/gestionDocumental/GenerarFichaGafas.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
        idFichaGafas: currentGlassesEdit.idFichaGafas,
        agente: userData.nombre + " " + userData.apellidos,
        tipoFicha: data.record,
        observaciones: data.observations,
        email: data.email,
      },
    );
    // console.log(
    // "GENERANDO: ",
    // {
    // token: userData.token,
    // idOptica: selectedOptic.id,
    // idFichaGafas: currentGlassesEdit.idFichaGafas,
    // agente: userData.nombre + " " + userData.apellidos,
    // tipoFicha: data.record,
    // observaciones: data.observations,
    // email: data.email,
    // },
    // response,
    // );
    if (response.error !== "") {
      createPopupQuestion(
        response.error,
        () => {
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    } else {
      const a = document.createElement("a");
      a.href = response.fichero;
      a.download = `ficha_gafas.pdf`;
      a.click();
    }
  };

  const clickOnlineOrder = () => {
    window.open(ONLINE_ORDER_URL, "_blank");
  };

  useEffect(() => {
    async function initData() {
      await getGlassesHistory();
      await getRecordTypeList();
      await getFrameMaterialList();
      await getShapeList();
      await getLensesMaterialList();
      await getLensesTypeList();
      if (glassesId !== -1) {
        await getGlasses(glassesId);
      } else {
        setSelectedDate({
          id: -1,
          text: moment().format("YYYY-MM-DD HH:mm:ss"),
        });
        setCurrentGlassesEdit((prev) => ({
          ...prev,
          fechaCreacion: moment().format("YYYY-MM-DD HH:mm:ss"),
          idFichaGafas: -1,
          empleado: userData.nombre + " " + userData.apellidos,
        }));
        setCurrentGlasses((prev) => ({
          ...prev,
          fechaCreacion: moment().format("YYYY-MM-DD HH:mm:ss"),
          idFichaGafas: -1,
          empleado: userData.nombre + " " + userData.apellidos,
        }));
        createPopupQuestion(
          `Seleccione qué tipo de ficha de gafas desea.`,
          async () => {
            setCurrentGlassesEdit((prev) => ({
              ...prev,
              gafasSol: false,
            }));
            focusElement(61);
            removePopupQuestion();
          },
          async () => {
            setCurrentGlassesEdit((prev) => ({
              ...prev,
              gafasSol: true,
            }));
            focusElement(61);
            removePopupQuestion();
          },
          "Vista",
          "Sol",
        );
      }
      setLoadingData(false);
      setTimeout(() => focusElement(61), 0);
    }
    initData();
  }, [glassesId]);

  useEffect(() => {
    getInsurance();
    getProgressiveData();
    getExtras();
  }, [currentGlassesEdit.idFicha]);

  useEffect(() => {
    getHealthData();
  }, [
    currentGlassesEdit.datosMontura.codigo,
    currentGlassesEdit.datosLenteOD.codigo,
    currentGlassesEdit.datosLenteOI.codigo,
  ]);

  useEffect(() => {
    if (actionComponent !== null) {
      setActionPopup(true);
    }
  }, [actionComponent]);

  useEffect(() => {
    if (
      frameSupplierList.length > 0 &&
      currentGlassesEdit.datosMontura.nombreProveedor !== ""
    ) {
      const found = frameSupplierList.find((e) => {
        return e.text === currentGlassesEdit.datosMontura.nombreProveedor;
      });

      setSelectedFrameSupplier(
        found || {
          id: -1,
          text: "",
        },
      );
    }
  }, [frameSupplierList, currentGlassesEdit.datosMontura.nombreProveedor]);

  useEffect(() => {
    if (
      rightLensSupplierList.length > 0 &&
      currentGlassesEdit.datosLenteOD.nombreProveedor !== ""
    ) {
      const found = rightLensSupplierList.find((e) => {
        return e.text === currentGlassesEdit.datosLenteOD.nombreProveedor;
      });
      setSelectedRightLensSupplier(
        found || {
          id: -1,
          text: "",
        },
      );
    }
  }, [rightLensSupplierList, currentGlassesEdit.datosLenteOD.nombreProveedor]);

  useEffect(() => {
    if (
      leftLensSupplierList.length > 0 &&
      currentGlassesEdit.datosLenteOI.nombreProveedor !== ""
    ) {
      const found = leftLensSupplierList.find((e) => {
        return e.text === currentGlassesEdit.datosLenteOI.nombreProveedor;
      });
      setSelectedLeftLensSupplier(
        found || {
          id: -1,
          text: "",
        },
      );
    }
  }, [leftLensSupplierList, currentGlassesEdit.datosLenteOI.nombreProveedor]);

  useEffect(() => {
    const newTotal = calculateTotal();
    setTotal(newTotal);
  }, [
    currentGlassesEdit.datosMontura.total,
    currentGlassesEdit.datosLenteOD.total,
    currentGlassesEdit.datosLenteOD.totalTratamiento,
    currentGlassesEdit.datosLenteOI.total,
    currentGlassesEdit.datosLenteOI.totalTratamiento,
    extras,
  ]);

  return (
    <div className="popup-container">
      {actionPopup && (
        <ActionPopup
          name={actionComponent.name}
          children={actionComponent.component}
          onClose={() => {
            reloadACList();
            setActionPopup(false);
            setActionComponent(null);
          }}
        ></ActionPopup>
      )}
      {toggleObservationPanel && (
        <ObservationsPanel
          objectInfo={currentGlassesEdit.idFicha}
          category="Ficha"
          onClose={async () => {
            setToggleObservationPanel(false);
            refreshObservations();
          }}
        ></ObservationsPanel>
      )}
      {toggleRepairPanel && (
        <ObservationsPanel
          repair={true}
          objectInfo={currentGlassesEdit.idFicha}
          category="Reparacion"
          onClose={async () => {
            setToggleRepairPanel(false);
            refreshRepairs();
          }}
        ></ObservationsPanel>
      )}
      {reportPopup && (
        <GlassesReportPopup
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
          onExport={async (data) => {
            await printFile(data);
          }}
          onClose={() => {
            setReportPopup(false);
          }}
        />
      )}
      <CentralCatalogPopup
        show={centralCatalogPopup !== null}
        ojo={centralCatalogPopup ?? "OD"}
        createPopupQuestion={createPopupQuestion}
        removePopupQuestion={removePopupQuestion}
        initialFilters={(() => {
          const eye =
            centralCatalogPopup === "OI"
              ? currentGlassesEdit.datosLenteOI
              : currentGlassesEdit.datosLenteOD;
          const cilNum = eye.cil !== "" ? parseFloat(eye.cil) : NaN;
          if (!isNaN(cilNum) && cilNum < 0) {
            const esfNum = eye.esf !== "" ? parseFloat(eye.esf) : 0;
            return {
              ind: eye.ind,
              esf: (esfNum + cilNum).toFixed(2),
              cil: (-cilNum).toFixed(2),
              add: eye.add,
              dia: eye.dia,
            };
          }
          return {
            ind: eye.ind,
            cil: eye.cil,
            esf: eye.esf,
            add: eye.add,
            dia: eye.dia,
          };
        })()}
        onClose={() => setCentralCatalogPopup(null)}
        onCargar={(rawData) => {
          const openEye =
            centralCatalogPopup === "OI"
              ? currentGlassesEdit.datosLenteOI
              : currentGlassesEdit.datosLenteOD;
          const origCilNum = openEye.cil !== "" ? parseFloat(openEye.cil) : NaN;
          const data = (() => {
            if (
              !isNaN(origCilNum) &&
              origCilNum < 0 &&
              rawData.esf !== "" &&
              rawData.cil !== ""
            ) {
              const esfN = parseFloat(rawData.esf);
              const cilN = parseFloat(rawData.cil);
              if (!isNaN(esfN) && !isNaN(cilN)) {
                return {
                  ...rawData,
                  esf: (esfN + cilN).toFixed(2),
                  cil: (-cilN).toFixed(2),
                };
              }
            }
            return rawData;
          })();
          setCentralCatalogPopup(null);
          if (data.ojo === "OD" || data.ojo === "AMBOS") setTarifaOD(data);
          if (data.ojo === "OI" || data.ojo === "AMBOS") setTarifaOI(data);

          const matchedSupplier =
            leftLensSupplierList.find(
              (s) => s.text.toUpperCase() === data.provider,
            ) ?? null;

          const tratamientoText = [
            data.tratamiento,
            ...data.instEspeciales,
            ...data.instMontaje,
          ]
            .filter(Boolean)
            .map((t) => t.texto)
            .filter(Boolean)
            .join(", ");

          const disponibilidad =
            data.tipo === "RX" ? "RX" : data.tipo === "SX" ? "Stock" : "";

          const applyToEye = (handleChange) => {
            if (matchedSupplier) {
              handleChange("nombreProveedor", matchedSupplier.text);
              handleChange("idProveedor", matchedSupplier.id);
            }
            handleChange("marca", "");
            handleChange("nombreComercial", data.descripcionProducto);
            handleChange("tipo", data.tipoLente?.Descripcion ?? "");
            handleChange("material", data.material?.Descripcion ?? "");
            handleChange("color", data.color?.Descripcion ?? "");
            handleChange("tratamiento", tratamientoText);
            handleChange("disponibilidad", disponibilidad);
            handleChange("pvp", data.totalLentes);
            handleChange("total", data.totalLentes);
            handleChange("descuento", 0);
            handleChange("pvpTratamiento", data.totalSuplementos);
            handleChange("totalTratamiento", data.totalSuplementos);
            handleChange("descuentoTratamiento", 0);
            handleChange("ind", data.ind);
            if (data.esf !== "") handleChange("esf", data.esf);
            if (data.cil !== "") handleChange("cil", data.cil);
            if (data.dia !== "") handleChange("dia", data.dia);
            if (data.add !== "") handleChange("add", data.add);
          };

          if (data.ojo === "OD" || data.ojo === "AMBOS") {
            const effectiveEsfOD =
              data.esf !== "" ? data.esf : currentGlassesEdit.datosLenteOD.esf;
            const effectiveAddOD =
              data.add !== "" ? data.add : currentGlassesEdit.datosLenteOD.add;
            setSelectedRightLensSupplier(
              matchedSupplier ?? { id: -1, text: "" },
            );
            applyToEye(handleChangeRightLensData);
            handleChangeRightLensData(
              "totalLente",
              calculateTotalLens(effectiveEsfOD, effectiveAddOD),
            );
          }
          if (data.ojo === "OI" || data.ojo === "AMBOS") {
            const effectiveEsfOI =
              data.esf !== "" ? data.esf : currentGlassesEdit.datosLenteOI.esf;
            const effectiveAddOI =
              data.add !== "" ? data.add : currentGlassesEdit.datosLenteOI.add;
            setSelectedLeftLensSupplier(
              matchedSupplier ?? { id: -1, text: "" },
            );
            applyToEye(handleChangeLeftLensData);
            handleChangeLeftLensData(
              "totalLente",
              calculateTotalLens(effectiveEsfOI, effectiveAddOI),
            );
          }
        }}
      />
      <div className="popup-screen">
        <div className="popup-screen-header">
          <button
            className="popup-action-icon close-icon"
            onClick={async () => {
              if (!areObjectsEqual(currentGlasses, currentGlassesEdit)) {
                createPopupQuestion(
                  "Existen cambios que no han sido guardados. ¿Desea guardar antes de salir?",
                  async () => {
                    removePopupQuestion();
                    await saveGlasses(onClose);
                  },
                  () => {
                    removePopupQuestion();
                    onClose();
                  },
                  "Sí",
                  "No",
                );
              } else {
                onClose();
              }
              await getGlassesHistory();
            }}
          >
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
          <span className="popup-screen-header-title">Ficha de gafas</span>
        </div>
        {loadingData && (
          <LoadingScreen message="Cargando ficha de gafas..."></LoadingScreen>
        )}
        {!loadingData && (
          <div className="tab-content background-gray" style={{ padding: 0 }}>
            <div
              className="popup-screen-actions"
              style={{ paddingBottom: 10, gap: 10 }}
            >
              <div className="popup-screen-box container-panel">
                <div className="popup-screen-box-info">
                  <div className="cell-extra">
                    <span className="label">Creación</span>
                  </div>
                  <div className="cell-extra w-220">
                    <div className="input-data input-full">
                      <input
                        type="datetime-local"
                        max="9999-12-31T23:59"
                        step="1"
                        tabIndex={133}
                        className="input-field input-cell"
                        value={currentGlassesEdit.fechaCreacion}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            fechaCreacion: e.target.value,
                          });
                        }}
                        onKeyUp={(e) => inputOnEnter(e)}
                      ></input>
                    </div>
                  </div>
                  <div className="cell-extra">
                    <span className="label">Entrega</span>
                  </div>
                  <div className="cell-extra w-220">
                    <div className="input-data input-full">
                      <input
                        type="date"
                        max="9999-12-31"
                        tabIndex={134}
                        className="input-field"
                        value={currentGlassesEdit.fechaEntrega}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            fechaEntrega: e.target.value,
                          });
                        }}
                        onKeyUp={(e) => inputOnEnter(e)}
                      ></input>
                    </div>
                  </div>
                  <div className="cell-extra">
                    <span className="label">Actualización</span>
                  </div>
                  <div className="cell-extra w-220">
                    <InputData
                      size={0}
                      input={moment(
                        currentGlassesEdit.fechaActualizacion,
                      ).format("DD/MM/YYYY HH:mm:ss")}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell-extra">
                    <span className="label">Revisión</span>
                  </div>
                  <div className="cell-extra w-220">
                    <div className="input-data input-full">
                      <input
                        type="date"
                        max="9999-12-31"
                        tabIndex={136}
                        className="input-field"
                        value={currentGlassesEdit.fechaRevision}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            fechaRevision: e.target.value,
                          });
                        }}
                        onKeyUp={(e) => inputOnEnter(e)}
                      ></input>
                    </div>
                  </div>
                  <div className="cell-extra">
                    <span className="label">
                      Histórico ({dateHistoryList.length})
                    </span>
                  </div>
                  <div className="cell-extra w-100p">
                    <DropdownFilter
                      tabIndex={137}
                      selectedOptions={[]}
                      optionList={dateHistoryList.map((item) => ({
                        id: item.idFichaGafas,
                        text: moment(item.fecha, "YYYY-MM-DD HH:mm:ss").format(
                          "DD/MM/YYYY HH:mm:ss",
                        ),
                        active: selectedDate.id === item.idFichaGafas,
                      }))}
                      size={0}
                      op={moment(
                        selectedDate.text,
                        "YYYY-MM-DD HH:mm:ss",
                      ).format("DD/MM/YYYY HH:mm:ss")}
                      disabled={glassesId === -1}
                      onChange={async (e) => {
                        setLoadingData(true);
                        setCurrentGlassesEdit(glassesStructure);
                        setSelectedDate({
                          id: e.id,
                          text: moment(e.text, "DD/MM/YYYY HH:mm:ss").format(
                            "YYYY-MM-DD HH:mm:ss",
                          ),
                        });
                        setGlassesId(e.id);
                      }}
                    ></DropdownFilter>
                  </div>
                  <div className="selector-glasses-type combined-cells-2">
                    <div className="cell-extra">
                      <div
                        className={`check-container-content cell-label cell-start-content ${
                          !currentGlassesEdit.gafasSol
                            ? "active-check-container"
                            : ""
                        }`}
                        style={{
                          height: 28,
                          justifyContent: "space-between",
                          cursor: "auto",
                        }}
                      >
                        <span>Vista</span>
                      </div>
                    </div>
                    <div className="cell-extra">
                      <div
                        className={`check-container-content cell-label cell-start-content ${
                          currentGlassesEdit.gafasSol
                            ? "active-check-container"
                            : ""
                        }`}
                        style={{
                          height: 28,
                          justifyContent: "space-between",
                          cursor: "auto",
                        }}
                      >
                        <span>Sol</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="popup-screen-box container-panel">
                <ButtonIconV
                  text="Nuevo"
                  icon={
                    glassesId !== -1
                      ? "/images/create-blue.svg"
                      : "/images/create-gray.svg"
                  }
                  onClick={() => {
                    if (glassesId !== -1) {
                      if (
                        !areObjectsEqual(currentGlasses, currentGlassesEdit)
                      ) {
                        createPopupQuestion(
                          `Existen cambios sin guardar en la ficha actual. ¿Desea guardar los cambios antes de crear una nueva ficha?`,
                          async () => {
                            await saveGlasses();
                            removePopupQuestion();
                            resetGlassesState();
                          },
                          async () => {
                            removePopupQuestion();
                            resetGlassesState();
                          },
                          "Sí",
                          "No",
                        );
                      } else {
                        resetGlassesState();
                      }
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Reposición"
                  icon={
                    glassesId !== -1
                      ? "/images/clone-blue.svg"
                      : "/images/clone-gray.svg"
                  }
                  onClick={() => {
                    if (glassesId !== -1) {
                      createPopupQuestion(
                        `¿Desea realizar reposición de esta ficha de gafas?`,
                        async () => {
                          await cloneGlasses();
                          removePopupQuestion();
                        },
                        async () => {
                          removePopupQuestion();
                        },
                        "Sí",
                        "No",
                      );
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="P. Telemático"
                  icon={
                    glassesId !== -1
                      ? "/images/support-extra/pedido-online.svg"
                      : "/images/support-extra/pedido-online-gray.svg"
                  }
                  onClick={glassesId !== -1 ? clickOnlineOrder : null}
                ></ButtonIconV>
                <ButtonIconV
                  text="Guardar"
                  icon="/images/save-blue.svg"
                  onClick={async () => {
                    await saveGlasses();
                    await getGlassesHistory();
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Cancelar"
                  icon="/images/cancel-blue.svg"
                  onClick={() => {
                    if (
                      dateHistoryList.length === 0 &&
                      areObjectsEqual(currentGlasses, currentGlassesEdit)
                    ) {
                      removePopupQuestion();
                    } else if (
                      !areObjectsEqual(currentGlasses, currentGlassesEdit) ||
                      glassesId === -1
                    ) {
                      createPopupQuestion(
                        `¿Desea cancelar los cambios realizados?`,
                        async () => {
                          await cancelChanges();
                          removePopupQuestion();
                        },
                        async () => {
                          removePopupQuestion();
                        },
                        "Sí",
                        "No",
                      );
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Recargar"
                  icon={
                    glassesId !== -1
                      ? "/images/update-blue.svg"
                      : "/images/update-gray.svg"
                  }
                  onClick={() => {
                    if (glassesId !== -1) {
                      createPopupQuestion(
                        `¿Desea recargar esta ficha de gafas?`,
                        async () => {
                          await getGlasses(glassesId);
                          removePopupQuestion();
                        },
                        async () => {
                          removePopupQuestion();
                        },
                        "Sí",
                        "No",
                      );
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Eliminar"
                  icon={
                    glassesId !== -1
                      ? "/images/remove-blue.svg"
                      : "/images/remove-gray.svg"
                  }
                  onClick={async () => {
                    if (glassesId !== -1) {
                      createPopupQuestion(
                        `¿Desea eliminar esta ficha de gafas?`,
                        async () => {
                          await deleteGlasses();
                          await getGlassesHistory();
                          await selectGlassesAfterDeleting();
                          removePopupQuestion();
                        },
                        async () => {
                          removePopupQuestion();
                        },
                        "Sí",
                        "No",
                      );
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Imprimir"
                  icon={
                    glassesId !== -1
                      ? "/images/print-blue.svg"
                      : "/images/print-gray.svg"
                  }
                  onClick={async () => {
                    if (glassesId !== -1) {
                      setReportPopup(true);
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Finalizar"
                  icon={
                    glassesId !== -1
                      ? "/images/shopping-cart-blue.svg"
                      : "/images/shopping-cart-gray.svg"
                  }
                  onClick={() => {
                    if (glassesId !== -1) {
                      handleOpenActionPopup("sales");
                    } else {
                      checkSaved();
                    }
                  }}
                ></ButtonIconV>
              </div>
            </div>
            <div className="popup-screen-content">
              <div
                className="popup-screen-content-col w-70"
                style={{ gap: 10 }}
              >
                <div className="container-panel">
                  <div className="opt-table-title">Datos montura</div>
                  <div
                    className="opt-table-content grid-5"
                    id="glasses-content-grid"
                  >
                    <div className="cell cell-label cell-start-content">
                      Código
                    </div>
                    <div className="cell cell-start-content">
                      <InputIconSearch
                        tabIndex={61}
                        type="type-only-numbers"
                        size={6}
                        maxLength={10}
                        input={currentGlassesEdit.datosMontura.codigo}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosMontura: {
                              ...currentGlassesEdit.datosMontura,
                              codigo: e,
                            },
                          });
                        }}
                        onClear={() => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosMontura: glassesStructure.datosMontura,
                          });
                          setSelectedFrameSupplier({
                            id: -1,
                            text: "",
                          });
                          focusElement(61);
                        }}
                        onEnter={searchFrameByCode}
                      ></InputIconSearch>
                      <ButtonIconH
                        text="Añadir"
                        small
                        onClick={() => {
                          handleOpenActionPopup("addFrame");
                        }}
                      ></ButtonIconH>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Proveedor
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={62}
                        optionList={frameSupplierList}
                        size={0}
                        disabled={true}
                        mandatory={false}
                        op={currentGlassesEdit.datosMontura.nombreProveedor}
                        onChange={(e) => {
                          handleChangeFrameData("nombreProveedor", e.text);
                          handleChangeFrameData("idProveedor", e.id);
                          const supplierToSet = frameSupplierList.find(
                            (supplier) => supplier.id === e.id,
                          ) ?? {
                            id: -1,
                            text: "",
                          };
                          setSelectedFrameSupplier(supplierToSet);
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Género
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={70}
                        optionList={genderProductOptions}
                        size={0}
                        op={currentGlassesEdit.datosMontura.genero}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosMontura: {
                              ...currentGlassesEdit.datosMontura,
                              genero: e.id,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Marca
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={63}
                        optionList={frameBrandList}
                        size={0}
                        op={currentGlassesEdit.datosMontura.marca}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosMontura: {
                              ...currentGlassesEdit.datosMontura,
                              marca: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Color
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={71}
                        maxLength={20}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentGlassesEdit.datosMontura.color}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosMontura: {
                              ...currentGlassesEdit.datosMontura,
                              color: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Modelo
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={64}
                        optionList={frameModelsList}
                        size={0}
                        op={currentGlassesEdit.datosMontura.modelo}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosMontura: {
                              ...currentGlassesEdit.datosMontura,
                              modelo: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Color lente
                    </div>
                    <div className="cell">
                      <InputData
                        inactive={!currentGlassesEdit.gafasSol}
                        tabIndex={72}
                        maxLength={20}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentGlassesEdit.datosMontura.colorCristal}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosMontura: {
                              ...currentGlassesEdit.datosMontura,
                              colorCristal: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Calibre x puente
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={65}
                        type="type-integer"
                        size={0}
                        input={currentGlassesEdit.datosMontura.calibre1}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosMontura: {
                              ...currentGlassesEdit.datosMontura,
                              calibre1: e,
                            },
                          });
                        }}
                      ></InputData>
                      <span className="cell-label">x</span>
                      <InputData
                        tabIndex={66}
                        type="type-integer"
                        size={0}
                        input={currentGlassesEdit.datosMontura.calibre2}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosMontura: {
                              ...currentGlassesEdit.datosMontura,
                              calibre2: e,
                            },
                          });
                        }}
                      ></InputData>
                      <span className="cell-label">Varilla</span>
                      <InputData
                        tabIndex={67}
                        type="type-integer"
                        size={0}
                        input={currentGlassesEdit.datosMontura.varilla}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosMontura: {
                              ...currentGlassesEdit.datosMontura,
                              varilla: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content"></div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Material
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={68}
                        optionList={frameMaterialList}
                        size={0}
                        op={currentGlassesEdit.datosMontura.material}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosMontura: {
                              ...currentGlassesEdit.datosMontura,
                              material: e.id,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Forma
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={69}
                        optionList={shapeList}
                        size={0}
                        op={currentGlassesEdit.datosMontura.forma}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosMontura: {
                              ...currentGlassesEdit.datosMontura,
                              forma: e.id,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell combined-cells-2">
                      <div className="opt-table-content grid-8-summary">
                        <div className="cell cell-label cell-start-content">
                          PVP
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={73}
                            type="type-positive-float"
                            size={6}
                            input={currentGlassesEdit.datosMontura.pvp}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurPrice(
                                e,
                                "datosMontura",
                                "pvp",
                                "descuento",
                                "total",
                              )
                            }
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell cell-label cell-start-content">
                          DTO %
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={74}
                            type="type-positive-integer"
                            size={6}
                            input={roundDto(
                              currentGlassesEdit.datosMontura.descuento,
                            )}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurDiscount(
                                e,
                                "datosMontura",
                                "descuento",
                                "pvp",
                                "total",
                                true,
                              )
                            }
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell cell-label cell-start-content">
                          Total
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={75}
                            type="type-positive-float"
                            size={6}
                            input={currentGlassesEdit.datosMontura.total}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurLineTotal(
                                e,
                                "datosMontura",
                                "pvp",
                                "descuento",
                                "total",
                                currentGlassesEdit.datosMontura.dtoMaximo,
                                75,
                              )
                            }
                          ></InputData>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="container-panel">
                  <div className="opt-table-title">Datos lente OD</div>
                  <div
                    className="opt-table-content grid-5"
                    id="glasses-content-grid"
                  >
                    <div className="cell cell-label cell-start-content">
                      Código
                    </div>
                    <div className="cell cell-start-content">
                      <InputIconSearch
                        tabIndex={76}
                        type="type-only-numbers"
                        size={6}
                        maxLength={10}
                        input={currentGlassesEdit.datosLenteOD.codigo}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              codigo: e,
                            },
                          });
                        }}
                        onClear={() => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: glassesStructure.datosLenteOD,
                          });
                          setSelectedRightLensSupplier({
                            id: -1,
                            text: "",
                          });
                          focusElement(76);
                        }}
                        onEnter={() => searchLensByCode(0)}
                      ></InputIconSearch>
                      <ButtonIconH
                        text="Añadir"
                        small
                        onClick={() => {
                          handleOpenActionPopup("addRightLens");
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Tarifa"
                        small
                        onClick={() => setCentralCatalogPopup("OD")}
                      ></ButtonIconH>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Opciones
                    </div>
                    <div
                      className="cell"
                      style={{ justifyContent: "space-between" }}
                    >
                      <ButtonIconH
                        text="Copiar a lente OI"
                        small
                        onClick={() => {
                          manageOptionsR(1);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Cargar Rx"
                        small
                        onClick={() => {
                          manageOptionsR(2);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Trasposición"
                        small
                        onClick={() => {
                          manageOptionsR(3);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Descentramiento"
                        small
                        onClick={() => {
                          manageOptionsR(4);
                        }}
                      ></ButtonIconH>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Proveedor
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={77}
                        optionList={rightLensSupplierList}
                        size={0}
                        disabled={true}
                        mandatory={false}
                        op={currentGlassesEdit.datosLenteOD.nombreProveedor}
                        onChange={(e) => {
                          handleChangeRightLensData("nombreProveedor", e.text);
                          handleChangeRightLensData("idProveedor", e.id);
                          const supplierToSet = rightLensSupplierList.find(
                            (supplier) => supplier.id === e.id,
                          ) ?? {
                            id: -1,
                            text: "",
                          };
                          setSelectedRightLensSupplier(supplierToSet);
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Marca
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={78}
                        optionList={rightLensBrandList}
                        size={0}
                        op={currentGlassesEdit.datosLenteOD.marca}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              marca: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Tipo
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={84}
                        optionList={lensesTypeList}
                        size={0}
                        op={currentGlassesEdit.datosLenteOD.tipo}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              tipo: e.id,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Nombre comercial
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={79}
                        optionList={rightLensModelsList}
                        size={0}
                        op={currentGlassesEdit.datosLenteOD.nombreComercial}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              nombreComercial: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Disponibilidad
                    </div>
                    <div className="cell cell-start-content">
                      <Dropdown
                        tabIndex={85}
                        optionList={availabilityProductOptions}
                        size={0}
                        op={currentGlassesEdit.datosLenteOD.disponibilidad.toUpperCase()}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              disponibilidad: e.id,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Material
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={80}
                        optionList={lensesMaterialList}
                        size={0}
                        op={currentGlassesEdit.datosLenteOD.material}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              material: e.id,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Color
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={81}
                        maxLength={20}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentGlassesEdit.datosLenteOD.color}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              color: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell combined-cells-2">
                      <div className="opt-table-content grid-8-summary">
                        <div className="cell cell-label cell-start-content">
                          PVP
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={86}
                            type="type-positive-float"
                            size={6}
                            input={currentGlassesEdit.datosLenteOD.pvp}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurPrice(
                                e,
                                "datosLenteOD",
                                "pvp",
                                "descuento",
                                "total",
                              )
                            }
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell cell-label cell-start-content">
                          DTO %
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={87}
                            type="type-positive-integer"
                            size={6}
                            input={roundDto(
                              currentGlassesEdit.datosLenteOD.descuento,
                            )}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurDiscount(
                                e,
                                "datosLenteOD",
                                "descuento",
                                "pvp",
                                "total",
                                true,
                              )
                            }
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell cell-label cell-start-content">
                          Total
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={88}
                            type="type-positive-float"
                            size={6}
                            input={currentGlassesEdit.datosLenteOD.total}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurLineTotal(
                                e,
                                "datosLenteOD",
                                "pvp",
                                "descuento",
                                "total",
                                currentGlassesEdit.datosLenteOD.dtoMaximo,
                                88,
                              )
                            }
                          ></InputData>
                        </div>
                      </div>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Tratamiento
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={82}
                        maxLength={40}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentGlassesEdit.datosLenteOD.tratamiento}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              tratamiento: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell combined-cells-2">
                      <div className="opt-table-content grid-8-summary">
                        <div className="cell cell-label cell-start-content">
                          PVP T
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={89}
                            type="type-positive-float"
                            size={6}
                            input={
                              currentGlassesEdit.datosLenteOD.pvpTratamiento
                            }
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurPrice(
                                e,
                                "datosLenteOD",
                                "pvpTratamiento",
                                "descuentoTratamiento",
                                "totalTratamiento",
                              )
                            }
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell cell-label cell-start-content">
                          DTO % T
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={90}
                            type="type-positive-integer"
                            size={6}
                            input={roundDto(
                              currentGlassesEdit.datosLenteOD
                                .descuentoTratamiento,
                            )}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurDiscount(
                                e,
                                "datosLenteOD",
                                "descuentoTratamiento",
                                "pvpTratamiento",
                                "totalTratamiento",
                                false,
                              )
                            }
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell cell-label cell-start-content">
                          Total T
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={91}
                            type="type-positive-float"
                            size={6}
                            input={
                              currentGlassesEdit.datosLenteOD.totalTratamiento
                            }
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurLineTotal(
                                e,
                                "datosLenteOD",
                                "pvpTratamiento",
                                "descuentoTratamiento",
                                "totalTratamiento",
                                "",
                                91,
                              )
                            }
                          ></InputData>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="opt-table-content grid-9">
                    <div className="cell combined-cells-9"></div>
                    <div className="cell cell-label">Índ</div>
                    <div className="cell cell-label">Esf</div>
                    <div className="cell cell-label">Cil</div>
                    <div className="cell cell-label">Eje</div>
                    <div className="cell cell-label">Add</div>
                    <div className="cell cell-label">Total</div>
                    <div className="cell cell-label">Diá</div>
                    <div className="cell cell-label">Alt</div>
                    <div className="cell cell-label">Des</div>
                    <div className="cell">
                      <InputData
                        tabIndex={92}
                        type="type-float2"
                        size={0}
                        input={currentGlassesEdit.datosLenteOD.ind}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              ind: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputDataControl
                        tabIndex={93}
                        type="type-optofloat"
                        size={0}
                        inactive={
                          currentGlassesEdit.tipoGafa === "CE" ||
                          currentGlassesEdit.tipoGafa === "IN"
                        }
                        input={currentGlassesEdit.datosLenteOD.esf}
                        minValue=""
                        maxValue=""
                        step={0.25}
                        numDecimales=""
                        createPopupQuestion={createPopupQuestion}
                        removePopupQuestion={removePopupQuestion}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              esf: e,
                            },
                          });
                        }}
                        onBlur={() => {
                          if (currentGlassesEdit.datosLenteOD.add) {
                            setCurrentGlassesEdit({
                              ...currentGlassesEdit,
                              datosLenteOD: {
                                ...currentGlassesEdit.datosLenteOD,
                                totalLente: calculateTotalLens(
                                  currentGlassesEdit.datosLenteOD.esf,
                                  currentGlassesEdit.datosLenteOD.add,
                                ),
                              },
                            });
                          } else if (
                            currentGlassesEdit.datosLenteOD.totalLente
                          ) {
                            setCurrentGlassesEdit({
                              ...currentGlassesEdit,
                              datosLenteOD: {
                                ...currentGlassesEdit.datosLenteOD,
                                add: calculateAddFromTotal(
                                  currentGlassesEdit.datosLenteOD.esf,
                                  currentGlassesEdit.datosLenteOD.totalLente,
                                ),
                              },
                            });
                          }
                        }}
                      ></InputDataControl>
                    </div>
                    <div className="cell">
                      <InputDataControl
                        tabIndex={94}
                        type="type-optofloat"
                        size={0}
                        input={currentGlassesEdit.datosLenteOD.cil}
                        minValue=""
                        maxValue=""
                        step={0.25}
                        numDecimales=""
                        createPopupQuestion={createPopupQuestion}
                        removePopupQuestion={removePopupQuestion}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              cil: e,
                            },
                          });
                        }}
                      ></InputDataControl>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={95}
                        type="type-only-positive-numbers"
                        size={0}
                        maxLength={3}
                        input={currentGlassesEdit.datosLenteOD.eje}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              eje: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputDataControl
                        tabIndex={96}
                        type="type-optofloat"
                        size={0}
                        inactive={
                          currentGlassesEdit.tipoGafa === "CE" ||
                          currentGlassesEdit.tipoGafa === "IN" ||
                          currentGlassesEdit.tipoGafa === "LJ"
                        }
                        input={currentGlassesEdit.datosLenteOD.add}
                        minValue=""
                        maxValue=""
                        step={0.25}
                        numDecimales=""
                        createPopupQuestion={createPopupQuestion}
                        removePopupQuestion={removePopupQuestion}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              add: e,
                            },
                          });
                        }}
                        onBlur={() => {
                          if (currentGlassesEdit.datosLenteOD.add !== "") {
                            setCurrentGlassesEdit({
                              ...currentGlassesEdit,
                              datosLenteOD: {
                                ...currentGlassesEdit.datosLenteOD,
                                totalLente: calculateTotalLens(
                                  currentGlassesEdit.datosLenteOD.esf,
                                  currentGlassesEdit.datosLenteOD.add,
                                ),
                              },
                            });
                          }
                        }}
                      ></InputDataControl>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={97}
                        type="type-optofloat"
                        size={0}
                        inactive={currentGlassesEdit.tipoGafa === "LJ"}
                        input={currentGlassesEdit.datosLenteOD.totalLente}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              totalLente: e,
                            },
                          });
                        }}
                        onBlur={() => {
                          if (
                            currentGlassesEdit.datosLenteOD.totalLente !== ""
                          ) {
                            setCurrentGlassesEdit({
                              ...currentGlassesEdit,
                              datosLenteOD: {
                                ...currentGlassesEdit.datosLenteOD,
                                add: calculateAddFromTotal(
                                  currentGlassesEdit.datosLenteOD.esf,
                                  currentGlassesEdit.datosLenteOD.totalLente,
                                ),
                              },
                            });
                          }
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={98}
                        size={0}
                        maxLength={15}
                        forceCenter={true}
                        input={currentGlassesEdit.datosLenteOD.dia}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              dia: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={99}
                        type="type-float2"
                        size={0}
                        input={currentGlassesEdit.datosLenteOD.alt}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              alt: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={100}
                        type="type-float2"
                        size={0}
                        input={currentGlassesEdit.datosLenteOD.desc}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOD: {
                              ...currentGlassesEdit.datosLenteOD,
                              desc: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                  </div>
                </div>
                <div className="container-panel">
                  <div className="opt-table-title">Datos lente OI</div>
                  <div
                    className="opt-table-content grid-5"
                    id="glasses-content-grid"
                  >
                    <div className="cell cell-label cell-start-content">
                      Código
                    </div>
                    <div className="cell cell-start-content">
                      <InputIconSearch
                        tabIndex={101}
                        type="type-only-numbers"
                        size={6}
                        maxLength={10}
                        input={currentGlassesEdit.datosLenteOI.codigo}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              codigo: e,
                            },
                          });
                        }}
                        onClear={() => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: glassesStructure.datosLenteOI,
                          });
                          setSelectedLeftLensSupplier({
                            id: -1,
                            text: "",
                          });
                          focusElement(101);
                        }}
                        onEnter={() => searchLensByCode(1)}
                      ></InputIconSearch>
                      <ButtonIconH
                        text="Añadir"
                        small
                        onClick={() => {
                          handleOpenActionPopup("addLeftLens");
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Tarifa"
                        small
                        onClick={() => setCentralCatalogPopup("OI")}
                      ></ButtonIconH>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Opciones
                    </div>
                    <div
                      className="cell"
                      style={{ justifyContent: "space-between" }}
                    >
                      <ButtonIconH
                        text="Copiar a lente OD"
                        small
                        onClick={() => {
                          manageOptionsL(1);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Cargar Rx"
                        small
                        onClick={() => {
                          manageOptionsL(2);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Trasposición"
                        small
                        onClick={() => {
                          manageOptionsL(3);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Descentramiento"
                        small
                        onClick={() => {
                          manageOptionsL(4);
                        }}
                      ></ButtonIconH>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Proveedor
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={102}
                        optionList={leftLensSupplierList}
                        size={0}
                        disabled={true}
                        mandatory={false}
                        op={currentGlassesEdit.datosLenteOI.nombreProveedor}
                        onChange={(e) => {
                          handleChangeLeftLensData("nombreProveedor", e.text);
                          handleChangeLeftLensData("idProveedor", e.id);
                          const supplierToSet = leftLensSupplierList.find(
                            (supplier) => supplier.id === e.id,
                          ) ?? {
                            id: -1,
                            text: "",
                          };
                          setSelectedLeftLensSupplier(supplierToSet);
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Marca
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={103}
                        optionList={leftLensBrandList}
                        size={0}
                        op={currentGlassesEdit.datosLenteOI.marca}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              marca: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Tipo
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={109}
                        optionList={lensesTypeList}
                        size={0}
                        op={currentGlassesEdit.datosLenteOI.tipo}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              tipo: e.id,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Nombre comercial
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={104}
                        optionList={leftLensModelsList}
                        size={0}
                        op={currentGlassesEdit.datosLenteOI.nombreComercial}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              nombreComercial: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Disponibilidad
                    </div>
                    <div className="cell cell-start-content">
                      <Dropdown
                        tabIndex={110}
                        optionList={availabilityProductOptions}
                        size={0}
                        op={currentGlassesEdit.datosLenteOI.disponibilidad.toUpperCase()}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              disponibilidad: e.id,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Material
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={105}
                        optionList={lensesMaterialList}
                        size={0}
                        op={currentGlassesEdit.datosLenteOI.material}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              material: e.id,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Color
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={106}
                        maxLength={20}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentGlassesEdit.datosLenteOI.color}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              color: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell combined-cells-2">
                      <div className="opt-table-content grid-8-summary">
                        <div className="cell cell-label cell-start-content">
                          PVP
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={111}
                            type="type-positive-float"
                            size={6}
                            input={currentGlassesEdit.datosLenteOI.pvp}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurPrice(
                                e,
                                "datosLenteOI",
                                "pvp",
                                "descuento",
                                "total",
                              )
                            }
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell cell-label cell-start-content">
                          DTO %
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={112}
                            type="type-positive-integer"
                            size={6}
                            input={roundDto(
                              currentGlassesEdit.datosLenteOI.descuento,
                            )}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurDiscount(
                                e,
                                "datosLenteOI",
                                "descuento",
                                "pvp",
                                "total",
                                true,
                              )
                            }
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell cell-label cell-start-content">
                          Total
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={113}
                            type="type-positive-float"
                            size={6}
                            input={currentGlassesEdit.datosLenteOI.total}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurLineTotal(
                                e,
                                "datosLenteOI",
                                "pvp",
                                "descuento",
                                "total",
                                currentGlassesEdit.datosLenteOI.dtoMaximo,
                                113,
                              )
                            }
                          ></InputData>
                        </div>
                      </div>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Tratamiento
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={107}
                        maxLength={40}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentGlassesEdit.datosLenteOI.tratamiento}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              tratamiento: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell combined-cells-2">
                      <div className="cell combined-cells-2">
                        <div className="opt-table-content grid-8-summary">
                          <div className="cell cell-label cell-start-content">
                            PVP T
                          </div>
                          <div className="cell">
                            <InputData
                              tabIndex={114}
                              type="type-positive-float"
                              size={6}
                              input={
                                currentGlassesEdit.datosLenteOI.pvpTratamiento
                              }
                              onChange={() => {}}
                              onBlur={(e) =>
                                onBlurPrice(
                                  e,
                                  "datosLenteOI",
                                  "pvpTratamiento",
                                  "descuentoTratamiento",
                                  "totalTratamiento",
                                )
                              }
                            ></InputData>
                          </div>
                          <div className="cell"></div>
                          <div className="cell cell-label cell-start-content">
                            DTO % T
                          </div>
                          <div className="cell">
                            <InputData
                              tabIndex={115}
                              type="type-positive-integer"
                              size={6}
                              input={roundDto(
                                currentGlassesEdit.datosLenteOI
                                  .descuentoTratamiento,
                              )}
                              onChange={() => {}}
                              onBlur={(e) =>
                                onBlurDiscount(
                                  e,
                                  "datosLenteOI",
                                  "descuentoTratamiento",
                                  "pvpTratamiento",
                                  "totalTratamiento",
                                  false,
                                )
                              }
                            ></InputData>
                          </div>
                          <div className="cell"></div>
                          <div className="cell cell-label cell-start-content">
                            Total T
                          </div>
                          <div className="cell">
                            <InputData
                              tabIndex={116}
                              type="type-positive-float"
                              size={6}
                              input={
                                currentGlassesEdit.datosLenteOI.totalTratamiento
                              }
                              onChange={() => {}}
                              onBlur={(e) =>
                                onBlurLineTotal(
                                  e,
                                  "datosLenteOI",
                                  "pvpTratamiento",
                                  "descuentoTratamiento",
                                  "totalTratamiento",
                                  "",
                                  116,
                                )
                              }
                            ></InputData>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="opt-table-content grid-9">
                    <div className="cell combined-cells-9"></div>
                    <div className="cell cell-label">Índ</div>
                    <div className="cell cell-label">Esf</div>
                    <div className="cell cell-label">Cil</div>
                    <div className="cell cell-label">Eje</div>
                    <div className="cell cell-label">Add</div>
                    <div className="cell cell-label">Total</div>
                    <div className="cell cell-label">Diá</div>
                    <div className="cell cell-label">Alt</div>
                    <div className="cell cell-label">Des</div>
                    <div className="cell">
                      <InputData
                        tabIndex={117}
                        type="type-float2"
                        size={0}
                        input={currentGlassesEdit.datosLenteOI.ind}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              ind: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputDataControl
                        tabIndex={118}
                        type="type-optofloat"
                        size={0}
                        inactive={
                          currentGlassesEdit.tipoGafa === "CE" ||
                          currentGlassesEdit.tipoGafa === "IN"
                        }
                        input={currentGlassesEdit.datosLenteOI.esf}
                        minValue=""
                        maxValue=""
                        step={0.25}
                        numDecimales=""
                        createPopupQuestion={createPopupQuestion}
                        removePopupQuestion={removePopupQuestion}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              esf: e,
                            },
                          });
                        }}
                        onBlur={() => {
                          if (currentGlassesEdit.datosLenteOI.add) {
                            setCurrentGlassesEdit({
                              ...currentGlassesEdit,
                              datosLenteOI: {
                                ...currentGlassesEdit.datosLenteOI,
                                totalLente: calculateTotalLens(
                                  currentGlassesEdit.datosLenteOI.esf,
                                  currentGlassesEdit.datosLenteOI.add,
                                ),
                              },
                            });
                          } else if (
                            currentGlassesEdit.datosLenteOI.totalLente
                          ) {
                            setCurrentGlassesEdit({
                              ...currentGlassesEdit,
                              datosLenteOI: {
                                ...currentGlassesEdit.datosLenteOI,
                                add: calculateAddFromTotal(
                                  currentGlassesEdit.datosLenteOI.esf,
                                  currentGlassesEdit.datosLenteOI.totalLente,
                                ),
                              },
                            });
                          }
                        }}
                      ></InputDataControl>
                    </div>
                    <div className="cell">
                      <InputDataControl
                        tabIndex={119}
                        type="type-optofloat"
                        size={0}
                        input={currentGlassesEdit.datosLenteOI.cil}
                        minValue=""
                        maxValue=""
                        step={0.25}
                        numDecimales=""
                        createPopupQuestion={createPopupQuestion}
                        removePopupQuestion={removePopupQuestion}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              cil: e,
                            },
                          });
                        }}
                      ></InputDataControl>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={120}
                        type="type-only-positive-numbers"
                        size={0}
                        maxLength={3}
                        input={currentGlassesEdit.datosLenteOI.eje}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              eje: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputDataControl
                        tabIndex={121}
                        type="type-optofloat"
                        size={0}
                        inactive={
                          currentGlassesEdit.tipoGafa === "CE" ||
                          currentGlassesEdit.tipoGafa === "IN" ||
                          currentGlassesEdit.tipoGafa === "LJ"
                        }
                        input={currentGlassesEdit.datosLenteOI.add}
                        minValue=""
                        maxValue=""
                        step={0.25}
                        numDecimales=""
                        createPopupQuestion={createPopupQuestion}
                        removePopupQuestion={removePopupQuestion}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              add: e,
                            },
                          });
                        }}
                        onBlur={() => {
                          if (currentGlassesEdit.datosLenteOI.add !== "") {
                            setCurrentGlassesEdit({
                              ...currentGlassesEdit,
                              datosLenteOI: {
                                ...currentGlassesEdit.datosLenteOI,
                                totalLente: calculateTotalLens(
                                  currentGlassesEdit.datosLenteOI.esf,
                                  currentGlassesEdit.datosLenteOI.add,
                                ),
                              },
                            });
                          }
                        }}
                      ></InputDataControl>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={122}
                        type="type-optofloat"
                        size={0}
                        inactive={currentGlassesEdit.tipoGafa === "LJ"}
                        input={currentGlassesEdit.datosLenteOI.totalLente}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              totalLente: e,
                            },
                          });
                        }}
                        onBlur={() => {
                          if (
                            currentGlassesEdit.datosLenteOI.totalLente !== ""
                          ) {
                            setCurrentGlassesEdit({
                              ...currentGlassesEdit,
                              datosLenteOI: {
                                ...currentGlassesEdit.datosLenteOI,
                                add: calculateAddFromTotal(
                                  currentGlassesEdit.datosLenteOI.esf,
                                  currentGlassesEdit.datosLenteOI.totalLente,
                                ),
                              },
                            });
                          }
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={123}
                        size={0}
                        maxLength={15}
                        forceCenter={true}
                        input={currentGlassesEdit.datosLenteOI.dia}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              dia: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={124}
                        type="type-float2"
                        size={0}
                        input={currentGlassesEdit.datosLenteOI.alt}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              alt: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={125}
                        type="type-float2"
                        size={0}
                        input={currentGlassesEdit.datosLenteOI.desc}
                        onChange={(e) => {
                          setCurrentGlassesEdit({
                            ...currentGlassesEdit,
                            datosLenteOI: {
                              ...currentGlassesEdit.datosLenteOI,
                              desc: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="popup-screen-content-col w-30 container-panel full-height"
                style={{ gap: "20px" }}
              >
                <div className="opt-table-content grid-8">
                  <div className="cell cell-label combined-cells-2 cell-start-content">
                    Agente (*)
                  </div>
                  <div className="cell cell-label combined-cells-6 cell-start-content">
                    <Dropdown
                      tabIndex={126}
                      optionList={agentList}
                      size={0}
                      op={currentGlassesEdit.empleado}
                      mandatory={false}
                      onChange={(e) => {
                        setCurrentGlassesEdit({
                          ...currentGlassesEdit,
                          empleado: e.text,
                        });
                      }}
                    ></Dropdown>
                  </div>
                  <div className="cell cell-label combined-cells-2 cell-start-content">
                    Tipo ficha (*)
                  </div>
                  <div className="cell cell-label combined-cells-6 cell-start-content">
                    <Dropdown
                      tabIndex={127}
                      optionList={recordTypeList}
                      size={0}
                      op={currentGlassesEdit.tipoFicha}
                      mandatory={true}
                      onChange={(e) => {
                        setCurrentGlassesEdit({
                          ...currentGlassesEdit,
                          tipoFicha: e.id,
                        });
                      }}
                    ></Dropdown>
                  </div>
                  <div className="cell cell-label combined-cells-2 cell-start-content">
                    Tipo gafa (*)
                  </div>
                  <div className="cell cell-label combined-cells-6 cell-start-content">
                    <Dropdown
                      tabIndex={128}
                      optionList={[{ id: "", text: "" }, ...glassesTypeList]}
                      size={0}
                      op={currentGlassesEdit.tipoGafa}
                      mandatory={true}
                      onChange={(e) => {
                        setCurrentGlassesEdit({
                          ...currentGlassesEdit,
                          tipoGafa: e.id,
                        });
                      }}
                    ></Dropdown>
                  </div>
                  <div className="cell cell-label combined-cells-2 cell-start-content">
                    Gama
                  </div>
                  <div className="cell cell-label combined-cells-2 cell-start-content">
                    <Dropdown
                      tabIndex={129}
                      optionList={rangeOptions}
                      size={0}
                      op={currentGlassesEdit.gama}
                      mandatory={false}
                      onChange={(e) => {
                        setCurrentGlassesEdit({
                          ...currentGlassesEdit,
                          gama: e.id,
                        });
                      }}
                    ></Dropdown>
                  </div>
                  <div className="cell cell-label combined-cells-2">
                    Premontada
                  </div>
                  <div className="cell combined-cells-2 cell-start-content">
                    <div
                      className="data-field c-pointer"
                      onClick={() => {
                        setCurrentGlassesEdit({
                          ...currentGlassesEdit,
                          premontada: !currentGlassesEdit.premontada,
                        });
                      }}
                    >
                      <CheckBox
                        tabIndex={130}
                        active={currentGlassesEdit.premontada}
                        onClick={() => {}}
                      ></CheckBox>
                    </div>
                  </div>
                  <div className="cell cell-label combined-cells-2 cell-start-content">
                    Motivo
                  </div>
                  <div className="cell cell-label combined-cells-6 cell-start-content">
                    <Dropdown
                      tabIndex={131}
                      optionList={reasonList}
                      size={0}
                      op={currentGlassesEdit.motivoAgente}
                      mandatory={false}
                      onChange={(e) => {
                        setCurrentGlassesEdit({
                          ...currentGlassesEdit,
                          motivoAgente: e.id,
                        });
                      }}
                    ></Dropdown>
                  </div>
                </div>
                <SummarySectionBox
                  name="Observaciones"
                  numElements={observations.length}
                  onOpen={() => {
                    if (glassesId !== -1) {
                      setToggleObservationPanel(true);
                    } else {
                      checkSaved();
                    }
                  }}
                ></SummarySectionBox>
                <SummarySectionBox
                  name="Extras"
                  numElements={extras.length}
                  onOpen={() => {
                    if (glassesId !== -1) {
                      handleOpenActionPopup("extras");
                    } else {
                      checkSaved();
                    }
                  }}
                ></SummarySectionBox>
                <SummarySectionBox
                  name="Seguro"
                  active={
                    Object.keys(insurance).length > 0 &&
                    insurance.tipoSeguro !== "N"
                  }
                  onOpen={() => {
                    if (glassesId !== -1) {
                      handleOpenActionPopup("insurance");
                    } else {
                      checkSaved();
                    }
                  }}
                ></SummarySectionBox>
                <SummarySectionBox
                  name="Datos progresivos"
                  active={Object.keys(progressiveData).length > 0}
                  onOpen={() => {
                    if (glassesId !== -1) {
                      handleOpenActionPopup("progressiveData");
                    } else {
                      checkSaved();
                    }
                  }}
                ></SummarySectionBox>
                <SummarySectionBox
                  name="Datos sanitarios"
                  numElements={healthData.length}
                  onOpen={() => {
                    if (glassesId !== -1) {
                      handleOpenActionPopup("healthData");
                    } else {
                      checkSaved();
                    }
                  }}
                ></SummarySectionBox>
                <SummarySectionBox
                  name="Reparaciones"
                  numElements={repairs.length}
                  onOpen={() => {
                    if (glassesId !== -1) {
                      setToggleRepairPanel(true);
                    } else {
                      checkSaved();
                    }
                  }}
                ></SummarySectionBox>
                <div className="total-summary-content">
                  <div className="total-summary-info">
                    <div className="cell cell-label cell-start-content">
                      TOTAL
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={132}
                        type="type-positive-float"
                        size={6}
                        input={total}
                        onChange={() => {}}
                        onBlur={async (e) => {
                          const value = parseFloat(e);
                          if (isNaN(value) || value === roundPrice(total)) {
                            return;
                          }
                          await updateDiscounts(value);
                        }}
                      ></InputData>
                      €
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
